<template>
  <nuxt-link :to="path" class="block" @click.capture="handleClickPath">
    <div class="header">
      <ul v-if="false" class="actions">
        <li>
          <ButtonCircleIcon
            class="button-add"
            icon-name="nomad:star"
            theme="negative"
            size="x-small"
            icon-size="2.6rem"
            aria-label="Ajouter aux favoris"
            @click.capture="handleClickLike"
          />
        </li>
      </ul>
      <div class="video-wrapper">
        <img
          class="placeholder"
          src="~/assets/images/thumbnail-video-placeholder.png"
        />
        <img
          v-if="thumbnailUrl"
          class="thumbnail"
          :src="thumbnailUrl"
          :alt="text"
        />
        <Teleport to="body">
          <ChapterPostVideo
            v-if="isVideoVisible"
            :post-id="id"
            :video-url="videoUrl"
          />
        </Teleport>
      </div>
    </div>
    <h4>
      {{ text }}&nbsp;<Icon
        v-if="isTrialItem"
        class="icon-gift"
        size="2rem"
        name="fluent-emoji-flat:wrapped-gift"
      />
    </h4>
  </nuxt-link>
</template>
<script lang="ts" setup>
interface ViewProps {
  id: string;
  path?: string;
  text: string;
  lockedContent: string;
  contentType: string;
  thumbnailUrl: string;
  videoUrl: string;
}

const route = useRoute();

const dialogLockedContent = useDialogLockedContent();

const { categoryTrialContent } = inject(INJECT_CATEGORY_PAGE);

const isVideoVisible = ref<boolean>(false);

const props = defineProps({
  id: null,
  path: null,
  text: null,
  lockedContent: null,
  contentType: null,
  thumbnailUrl: null,
  videoUrl: null
});

const {
  handleClickPath,
  isTrialItem,
  isTrialAvailable,
  isATrialType,
  isLocked,
} = useCategoryContentClick(
  {
    lockedContent: props.lockedContent || props.contentType,
    id: props.id,
  },
  props.path
);

watch(
  () => route.fullPath,
  (path) => {
    isVideoVisible.value = path === props.path;
  }
);

const handleInitVideoUrl = async () => {
  if (route.fullPath === props.path) {
    if (isLocked && isATrialType.value) {
      if (isLocked && !isTrialAvailable.value) {
        dialogLockedContent.open(
          props.contentType,
          route.path,
          null,
          useAppEventShare(
            EventAssociatedModel.ContentLockScreen,
            props.id,
            props.contentType || props.lockedContent
          )
        );
      } else if (isLocked && isTrialAvailable.value && !isTrialItem.value) {
        await categoryTrialContent.saveTrialProgression(
          'course_video',
          props.id
        );
        isVideoVisible.value = true;
      }
    } else if (isLocked) {
      dialogLockedContent.open(
        props.contentType,
        route.path,
        null,
        useAppEventShare(
          EventAssociatedModel.ContentLockScreen,
          props.id,
          props.contentType || props.lockedContent
        )
      );
    } else {
      isVideoVisible.value = true;
    }
  }
};

onMounted(() => {
  handleInitVideoUrl();
});

const handleClickLike = () => {};
</script>
<style lang="scss" scoped>
.block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: var(--gap_s);
}
.header {
  display: flex;
  position: relative;
  flex-direction: column;
  padding: var(--gap_m);
  overflow: hidden;
  border-color: var(--color_neutral_25);
  gap: var(--gap_xs);
  @include stroke('l', 'm');
  &::after {
    content: '';
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform-origin: 50% 50%;
    transition: opacity 300ms $ease-in-quad;
    background-color: var(--color_secondary_lighter);
  }
}

.video-wrapper {
  position: relative;
}

.thumbnail {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: calc(var(--stroke_radius_m) - var(--gap_m) / 2);
}

.actions {
  display: flex;
  z-index: 1;
  justify-content: flex-end;
  background-color: var(--color_secondary_lighter);
  gap: var(--gap_xs);
}
img {
  z-index: 1;
  transition: box-shadow 340ms $ease-in-quad;
  box-shadow: rgb(0 0 0 / 0%) 0 2px 8px;
}

video {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

h4 {
  /* Calcul littéral et équations */
  @include font('s', 500, 'secondary');

  padding: 0 var(--gap_s);
  transition: color 300ms $ease-in-quad;
  text-align: center;
}

a {
  &:hover,
  &:focus {
    .header {
      &::after {
        transition: opacity 300ms $ease-out-quad;
        opacity: 0.5;
      }
    }
    h4 {
      transition: color 300ms $ease-out-quad;
      color: var(--color_secondary);
    }
    img {
      transition: box-shadow 340ms $ease-out-quad;
      box-shadow: rgb(0 0 0 / 10%) 0 2px 8px;
    }
  }
}
</style>
